import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { GridLegacy } from "@mui/material";
import FormTextTC from "../../../components/Forms/FormTextTC";

export default function SubsDebtorGeneral() {
  const infoFields = [
    "email_address",
    "invoice_email_address",
    "phone",
    "company_name",
    "company_address",
    "company_city",
    "company_postal_code",
    "company_country",
    "vat_number",
    "coc_number",
    "bank_account",
    "gripp_reference",
    "gripp_customer_number",
    "gripp_paymentmethod",
    "is_customer",
    "is_lead",
    "is_prospect",
    "is_supplier",
  ];

  const editableFields = ["gripp_templateset_id"];

  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <h3>{getTranslation("General")}</h3>
          </GridLegacy>
          {infoFields.map((fieldKey) => {
            return <FormTextTC disabled name={fieldKey} tDefault={fieldKey} tKey={"subsDebtors." + fieldKey} />;
          })}

          {editableFields.map((fieldKey) => {
            return <FormTextTC name={fieldKey} tDefault={fieldKey} tKey={"subsDebtors." + fieldKey} />;
          })}
        </GridLegacy>
      </CardBody>
    </Card>
  );
}
